import React from "react";
import { Link } from "react-router-dom";
import Icons from "../SocialMedia/Icons";
import { MdLocationOn } from "react-icons/md";
import { BsTelephoneFill } from "react-icons/bs";
import { MdEmail } from "react-icons/md";
import "./Footer";

export default function Footer() {
  return (
    <div className="footer_section padding_top_bottom">
      <div className="container">
        <div className="row">
          <div className="footer_item layout-col-lg-4 layout-col-md-6 layout-col-sm-12">
            <h1>Our Mission</h1>
            <p>
              We aim to provide turnkey solutions that mirror the best
              international standards by combining our own expertise and
              leverage to ensure world class Engineering Procurement and
              construction of Competitive prices.
            </p>
          </div>
          <div className="footer_item layout-col-lg-4 layout-col-md-6 layout-col-sm-12">
            <h1>Useful Links</h1>
            <Link to="/getintouch">Get In Touch</Link>
            <br />
            <Link to="/aboutus">About Us</Link>
            <br />
            <Link to="/services">Services</Link>
            <br />
            <Link to="/projects">Projects</Link>
            <br />
            <Link to="/inhouseexpertise">In-House Expertise</Link>
            <br />
            <Link to="/articles">News</Link>
          </div>
          <div className="footer_item layout-col-lg-4 layout-col-md-6 layout-col-sm-12">
            <h1>Get In Touch</h1>
            <p>
              <MdLocationOn />
              &nbsp; 11 Saise RD Rhodes Park Lusaka, Zambia
            </p>
            <p>
              <BsTelephoneFill />
              &nbsp; +260 964 810 627
            </p>
            <p>
              <MdEmail />
              &nbsp; elegroenergylimited@gmail.com
            </p>
            <Icons />
          </div>
        </div>
      </div>
    </div>
  );
}
